<div class="row">
  <div class="col-12 text-center" style="height: 100vh; padding-top: 20vh;">
    <h1>กำลังค้นหาข้อมูล</h1>
    <div class="snippet mt-5" data-title=".dot-elastic">
      <div class="stage">
        <div class="dot-elastic mx-auto"></div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/incoming-call/incoming-call.component.html